import apiCall from '../../../utility/api';

type dataProps = {
    automationId: any;
    setmessagebar2: any;
    setErrorToast: any;
    setmessagebar1: any;
    saveBtnClicked: any;
    setAttachmentStatus: any;
    setToastMessage: any;
    setAllAttachmentGrp: any;
    data: any;
    func: any;
    searchVal: String;
    pageNo: any;
    setTotalPages: any;
    setTotalRecords: any;
    setDartSpecs: any;
    setJsonData: any;
    setUiData: any;
    deleteAutomation: any;
    setDeleteAutomation: any;
    setDeleteDisabled: any;
    isRefresh: any;
    setRefresh: any;
    groupAttachment: any;
    groupDetachment: any;
    dartNo?: number;
    tenant?: string;
    automationName?: string;
    selectedRowIdInTable?: any[];
    automationType?: string;
}

const Remediations_assignment_func = (props: dataProps) => {

    const modifyRemediation = async () => {
        try {
            const attachment = props.groupAttachment;
            const detachment = props.groupDetachment;
            let collectionData: any = {};

            console.log("2props.automationType=", props.automationType);


            if (props.automationType === 'data_collection') {
                collectionData = await apiCall(`/remediation/data_collection/assignment`, { tenant: props.tenant, id: props.automationId, automation: props.automationName, attachment: attachment, detachment: detachment, types: 'data_collection' });
            } else if (props.automationType === 'app policy') {
                collectionData = await apiCall(`/remediation/app_policy/assignment`, { tenant: props.tenant, automation: props.automationName, attachment: attachment, detachment: detachment, types: 'app policy' });
            } else {
                collectionData = await apiCall(`/remediation/${props.automationType}/assignment`, { tenant: props.tenant, automation: props.automationName, attachment: attachment, detachment: detachment, types: props.automationType });
            }
            console.log("status=", collectionData.status);

            if (collectionData?.status === 'success') {
                props.setToastMessage(collectionData?.msg);
                props.setmessagebar1(false);
                props.setmessagebar2(true);
            } else {
                props.setmessagebar1(false);

                props.setErrorToast(true);
                props.setToastMessage("Assignment failed");
            }

            props.setAttachmentStatus(true);
        } catch (error) {
            console.log("modifyRemediation error=", error);

            props.setToastMessage("Assignment failed");
            props.setmessagebar1(false);

            props.setErrorToast(true);
            props.setAttachmentStatus(true);
        }
    }

    modifyRemediation();
}

export { Remediations_assignment_func }